export default __webpack_public_path__ + "static/Plots0015-2f6c2108195d42fc55e1dd9be04848fd.jpg";